module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[42]163.7cbe3f6.woff2";